import React from "react";
import {
  SignInLHSContainer,
  SignInParentContainer,
  SignInRHSContainer,
} from "../components/atoms/Containers";
import { SignUpForm } from "../components/molecules/forms/SignUpForm";
import { SignUpInfo } from "../components/molecules/overlayBoxes/SignUpInfo";

export const SignUp = () => (
  <SignInParentContainer>
    <SignInLHSContainer>
      <SignUpInfo />
    </SignInLHSContainer>
    <SignInRHSContainer>
      <SignUpForm />
    </SignInRHSContainer>
  </SignInParentContainer>
);
